// src/supabase.js — cliente Supabase singleton.
//
// Importado desde @supabase/supabase-js (npm, bundleado por Vite).
// Reemplaza al <script src="cdn.jsdelivr.net/.../supabase-js@2"> que cargaba
// el cliente como UMD global. Un módulo, un cliente — nunca dos clientes
// distintos en el mismo build, ver CLAUDE.md §7.
//
// FASE 4 · F1.2: opciones de auth explícitas.
//   - persistSession + autoRefreshToken: la sesión sobrevive recargas
//     (token en localStorage, refresco automático antes de vencer).
//   - detectSessionInUrl: crítico para cerrar el flujo OAuth de Google — el
//     redirect vuelve con el code/token en la URL y el cliente lo canjea solo.

import { createClient } from '@supabase/supabase-js'
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './config.js'
import { fetchWithTimeout } from './utils/timeout.js'

// Fix sistémico freeze-mobile (6-jun-2026): TODA request de Supabase pasa por un
// fetch con timeout duro de 15s (AbortController + setTimeout, sin
// AbortSignal.timeout por WebView viejo). Cierra de un saque los awaits sin
// timeout que quedaban (signOut, mutaciones, storage) Y el refresh silencioso de
// autoRefreshToken sobre conexión muerta post-suspensión en mobile. Los timeouts
// por-llamada (12s) siguen vigentes y abortan antes para las queries envueltas.
const SUPABASE_FETCH_TIMEOUT_MS = 15000

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Cross-context Chrome+PWA (5-jun-2026): navigatorLock (Web Locks) es global
    // por origen; si un contexto deja un lock huérfano, el otro espera hasta
    // robarlo. auth-js 2.105.4 ya recupera el huérfano con steal:true, pero al
    // default de lockAcquireTimeout=5000ms esos 5s se perciben como cuelgue.
    // Bajándolo a 2000ms la recuperación es más rápida. NO cambia la hidratación
    // (seguimos en navigatorLock, no processLock): el timer sólo actúa cuando el
    // lock NO está disponible; en el camino normal se cancela al adquirirlo. No
    // bajar de ~2000ms — nuestro fetch global permite hasta 15s, y un timeout
    // muy corto robaría locks de operaciones legítimas lentas.
    lockAcquireTimeout: 2000,
  },
  global: { fetch: fetchWithTimeout(SUPABASE_FETCH_TIMEOUT_MS) },
})
